import { render } from "./FathersAndStudents.vue?vue&type=template&id=0d241192"
import script from "./FathersAndStudents.vue?vue&type=script&lang=js"
export * from "./FathersAndStudents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__